<template>
  <v-app>
    <slot />

    <snackbar :show="show"></snackbar>
  </v-app>
</template>

<script setup>
import snackbar from '@/layouts/imports/snackbar'

import { useTheme } from 'vuetify'

const theme = useTheme()
const pimTheme = useCookie('pim_theme')

useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - Jovani` : 'Inventory JOVANI'
  }
})

const { show } = useSnackbarStore()

// data

// method
theme.global.name.value = pimTheme.value || 'light'
</script>
